// extracted by mini-css-extract-plugin
export default {"viewBuilderComponents":"components_viewBuilderComponents__yTw+Q"};